<template>
    <!-- 外部产品管理 -->
    <div class="insuredOrder main-container">
        <div class="content">
            <div class="search-box">
                <div class="input-item">
                    <span class="label">保险公司</span>
                    <Select v-model="searchParams.companyCode" clearable filterable>
                        <Option v-for="(bean, i) in companyList" :key="i" :value="bean.code">{{ bean.name }}</Option>
                    </Select>
                </div>
                <div class="input-item">
                    <span class="label">产品名称</span>
                    <Input v-model="searchParams.productName" placeholder="请输入" clearable />
                </div>
                <div class="input-item">
                    <span class="label">产品编码</span>
                    <Input v-model="searchParams.productCode" placeholder="请输入" clearable />
                </div>
                <div class="input-item">
                    <span class="label">业务类别</span>
                    <Select :multiple="true" v-model="searchParams.sellType" placeholder="请选择" clearable>
                        <Option value="1" label="网销产品"></Option>
                        <Option value="3" label="经代产品"></Option>
                    </Select>
                </div>
                <div class="input-item">
                    <span class="label">状态</span>
                    <Select v-model="searchParams.isAdd" clearable>
                        <Option value="0">可添加</Option>
                        <Option value="1">已添加</Option>
                    </Select>
                </div>
                <div class="btn-item">
                    <Button type="primary" @click="searchAjax()" style="width:80px">查询</Button>
                    <Button type="primary" ghost @click="resetSearch()">重置</Button>
                </div>
                <Button @click="back('/productResource/productManager')" type="primary" class="back-btn" ghost>返回</Button>
            </div>
            <div class="tableBox setTable">
                <loading :isShow="listLoading" />
                <div class="tableBox">
                    <Table :columns="columns" :data="tableData">
                        <template slot-scope="{ row }" slot="productName">
                            <div class="product-item">
                                <img v-if="row.isAdd == 1" class="ivu-checkmark"
                                    src="@static/images/product/icon_check1.png" alt="">
                                <span>{{ row.productName }}</span>
                            </div>
                        </template>
                        <template slot-scope="{ row }" slot="sellTypeSlot">
                            <div class="sellTypeColumn" v-if="row.sellType">
                                <Tag color="blue" v-if="row.sellType.includes('1')">网销</Tag>
                                <Tag color="blue" v-if="row.sellType.includes('2')">电销</Tag>
                                <Tag color="blue" v-if="row.sellType.includes('3')">经代</Tag>
                            </div>
                            <div v-else>/</div>
                        </template>
                        <template slot-scope="{ row }" slot="action">
                            <div class="detail">
                                <Poptip v-if="row.isAdd == 0" width="300" placement="left-start" transfer confirm
                                    :title="'确认导入产品“' + row.productName + '”吗？'" @on-ok="importPro(row)">
                                    <div>
                                        <span class="btn-import">
                                            <img class="icon-upload"
                                                src="@static/images/product/icon_upload.png" />导入</span>
                                    </div>
                                </Poptip>
                                <div v-if="row.canRenew == 1 && row.isAdd != 0" @click="refresh(row)">
                                    <span class="btn-refresh"> <img class="icon-upload"
                                            src="@static/images/product/icon_upload1.png" />更新</span>
                                </div>
                            </div>
                        </template>
                    </Table>
                    <div class="pageBox">
                        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList"
                            style="text-align: center" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
export default {
    name: 'productManager.product',
    data() {
        return {
            companyList: [],
            //表单搜索字段
            searchParams: {},
            columns: [
                {
                    title: '产品名称',
                    slot: 'productName',
                    align: 'center',
                    minWidth: 200
                },
                {
                    title: '产品编码',
                    key: 'productCode',
                    align: 'center'
                },
                {
                    title: '保险公司',
                    key: 'companyName',
                    align: 'center'
                },
                {
                    title: '业务类别',
                    key: 'sellType',
                    align: 'center',
                    slot: 'sellTypeSlot'
                },
                {
                    title: '状态',
                    key: 'isAdd',
                    align: 'center',
                    render(h, params) {
                        if (params.row.isAdd == 0) {
                            return (<span class='un-add'>可添加</span>)
                        } else {
                            return (<span class='added'>已添加</span>)
                        }
                        // return <span>{params.row.isAdd == 0 ? '可添加' : '已添加'}</span>
                    }
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: '130',
                    fixed: 'right'
                }
            ],
            tableData: []
        };
    },
    mixins: [pageTool, common],
    methods: {
        //列表保险公司
        geCompanyList() {
            this.$http({
                url: '/buz/insuranceCompany/read/all',
                type: 'POST',
                data: { companyType: '1' }
            }).then(res => {
                //赠险公司列表初始化
                this.companyList = res.data;
            });
        },
        setReqParams(params){
            params.apiPermissionCode = 'pro_2_4';
        },
        setListParams(params) {
            if (params.sellType && params.sellType.length > 0) {
                params.sellType =
                    params.sellType.length > 1 ? params.sellType.join('|') : params.sellType.length == 1 ? params.sellType.join(',') : '';
            } else {
                delete params.sellType;
            }
            if (params.insureType && params.insureType.length > 0) {
                params.insureType =
                    params.insureType.length > 1
                        ? params.insureType.join('|')
                        : params.insureType.length == 1
                            ? params.insureType.join(',')
                            : '';
            } else {
                delete params.insureType;
            }
        },
        importPro(row) {
            this.$http({
                url: '/buz/productBase/addFromPlatform',
                type: 'GET',
                data: { productCode: row.productCode }
            }).then(res => {
                this.$Message.success('操作成功');
                this.getList();
            });
        },
        refresh(row) {
            this.$Modal.confirm({
                okText: '确认更新',
                title: `系统总库更新将覆盖本地维护的产品基本信息与文档资料，请确认是否更新产品“${row.productName}”？`,
                render: (h, params) => {
                    return h("div", [
                        h(
                            "p",
                            {
                                style: {
                                    marginLeft: "10px",
                                },
                            },
                            "更新内容：" + row.renewMsg
                        ),
                    ]);
                },
                onOk: () => {
                    this.$http({
                        url: '/buz/productBase/editFromPlatform',
                        type: 'GET',
                        data: { productCode: row.productCode }
                    }).then(res => {
                        this.$Message.success('操作成功');
                        this.getList();
                    });
                }
            });
        }
    },
    activated() {
        this.initListAjax('/buz/productBase/queryPlatform');
    },
    mounted() {
        this.geCompanyList();
    }
};
</script>
<style lang="scss">
/deep/.ivu-poptip-body-message {
    word-break: break-all;
}
</style>
<style lang="scss" scoped>
/deep/ .ivu-switch-disabled.ivu-switch-checked {
    opacity: 1;
}

/deep/ .ivu-modal-body {
    padding: 16px 30px;
}

/deep/ .formGroup {
    position: relative;

    &:after {
        position: absolute;
        bottom: -5px;
        width: 100%;
        height: 20px;
        content: '';
        filter: blur(5px);
        background: #fff;
    }

    padding: 0;

    .title {
        font-size: 16px;
        font-weight: bold;
        color: #3c464f;
    }
}

.pageBox {
    margin-top: 20px;
}

@import './product.scss';
</style>
